module.exports = __webpack_public_path__ + "img/inputsearch.ac5104d4.svg";